<template>
  <div id="app">
    <nav-infoq></nav-infoq>
    <gi-nav :menu="data['导航栏']"></gi-nav>
    <!-- <div class="site-entry">
      <a href="" class="btn">重庆站</a>
    </div> -->
    <a :href="data.banner.link" target="_blank"
       class="banner is-tablet" :style="`background-image: url('${data['banner']['图片（pc）']}')`"></a>
    <a :href="data.banner.link" target="_blank"
       class="banner is-mobile" :style="`background-image: url('${data['banner']['图片（mobile）']}')`"></a>
    <!-- banner 按钮区域 -->
    <!--<div class="btn-area">-->
      <!--<div class="content">-->
        <!--<div class="btn-menu">-->
          <!--<span class="site-cq" @click="showMenu">重庆站 <span-->
            <!--:class="{'arrowicon-b':!btnShow, 'arrowicon-t':btnShow}"></span></span>-->
          <!--<a target="_blank" v-if="btnShow" href="http://www.infoq.com/cn/zones/tencentcloud/guangdong.html"-->
             <!--class="site-gz"> 广州站 </a>-->
        <!--</div>-->
        <!--<div class="btn-group" style="display: none;">-->
          <!--<a target="_blank" href="https://cloud.tencent.com/developer/summit/signup" class="precon">参会预约</a>-->
          <!--<a target="_blank" href="https://cloud.tencent.com/developer/summit/2018-chongqing" class="prelive">预约直播</a>-->
        <!--</div>-->
        <!--<a target="_blank" href="http://www.infoq.com/cn/zones/tencentcloud/guangdong.html" class="togzsite"> 去广州站-->
          <!--&gt; </a>-->
      <!--</div>-->
    <!--</div>-->
    <!-- 头条新闻 -->
    <div class="b-toutiao c-box" id="toutiao" v-if="data['头条新闻']['是否显示']">
      <gi-title :data="data['头条新闻'].title"></gi-title>
      <div class="container">
        <div class="columns is-gapless">
          <div class="column is-left is-one-third-tablet">
            <img :src="data['头条新闻']['图片']">
          </div>
          <div class="column is-right">
            <div class="right">
              <h1>{{data['头条新闻']['right']['标题']}}</h1>
              <p>{{data['头条新闻']['right']['介绍']}}</p>
              <div class="link">
                <a target="_blank" :href="data['头条新闻']['right']['link']">{{data['头条新闻']['right']['more']}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--讲师-->
    <div class="b-speakers c-box speakers" id="speakers" v-if="data['讲师介绍']['是否显示']">
      <gi-title :data="data['讲师介绍'].title"></gi-title>
      <speakers :speakers="data['讲师介绍']"></speakers>
    </div>

    <!--大会报道-->
    <div class="b-news c-box" id="news" v-if="data['实时报道']['是否显示']">
      <gi-title :data="data['实时报道'].title"></gi-title>
      <div class="container">
        <div class="columns is-multiline">
          <div v-for="item in news" v-if="item['图片']" class="column is-one-third-tablet">
            <gi-card :data="item"></gi-card>
          </div>
        </div>
        <div class="loadmore">
          <a @click="moreNews" class="button is-loadmore" v-if="news.length < len(newsbac)">加载更多>></a>
        </div>
      </div>
    </div>

    <div class="b-relative c-box" id="relative" v-if="data['相关新闻']['是否显示']"
         :style="{'background-image':'url(https://static.geekbang.org/infoq/5ae054b4255ca.png)'}">
      <div class="container">
        <gi-title :data="data['相关新闻'].title" theme="light"></gi-title>
        <ul class="list has-shadow">
          <a class="item" :href="info.link" target="_blank" v-for="(info, index) in data['相关新闻'].list"
             v-if="info['标题']">
            <h1>{{info['标题']}}</h1>
            <p>{{info['介绍']}}</p>
          </a>
        </ul>
        <div class="more" v-if="data['相关新闻']['more']['name']">
          <a :href="data['相关新闻']['more']['link']">{{data['相关新闻']['more']['name']}}</a>
        </div>
      </div>
    </div>

    <!-- 日程 -->
    <div class="b-news c-box" id="schedule" v-if="data['大会日程']['是否显示'] || true" style="background-color: #0c0c0c">
      <gi-title :data="data['大会日程'].title" theme="light"></gi-title>
      <div class="container">
        <scheduleb></scheduleb>
        <!-- <div class="display-tablet">
          <img :src="data['大会日程']['图片（pc）']">
        </div>
        <div class="display-mobile">
          <img :src="data['大会日程']['图片（mobile）']">
        </div> -->
      </div>
      <!-- <div class="loadmore">
        <a href="https://cloud.tencent.com/developer/summit/2018-guangzhou/agenda" target="_blank" class="button is-loadmore is-light">详细议程</a>
      </div> -->
    </div>

    <div class="b-video c-box" id="live" v-if="data['会场花絮']['是否显示']">
      <div class="container">
        <gi-title :data="data['会场花絮'].title"></gi-title>
        <div class="columns is-multiline">
          <div v-for="video in data['会场花絮']['list']" v-if="video['图片']" class="column is-one-third-tablet">
            <gi-card2 :data="video"></gi-card2>
          </div>
        </div>
      </div>
    </div>

    <div class="b-image c-box" id="image" v-if="data['现场图片']['是否显示']">
      <div class="container">
        <gi-title :data="data['现场图片'].title"></gi-title>
        <div class="swiper">
          <swiper :options="swiperOption">
            <swiper-slide v-for="(img, index) in data['现场图片']['图片链接']" :key="img" v-if="img">
              <img class="item" :src="img">
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
        <div class="link">
          <a :href="data['现场图片']['link']" v-if="data['现场图片']['more']">{{data['现场图片']['more']}}</a>
        </div>
      </div>
    </div>
    <div class="b-video c-box" id="video" v-if="data['视频回放']['是否显示']">
      <div class="container">
        <gi-title :data="data['视频回放'].title"></gi-title>
        <div class="columns is-multiline">
          <div v-for="video in videos" v-if="video['图片']" class="column is-one-third-tablet">
            <gi-card2 :data="video"></gi-card2>
          </div>
        </div>
        <div class="loadmore">
          <a @click="moreVideo" class="button is-loadmore" v-if="videos.length < len(data['视频回放'].list)">加载更多>></a>
        </div>
      </div>
    </div>
    <div class="b-partners c-box" id="partners" v-if="data['合作伙伴']['是否显示']">
      <partners :partners="data['合作伙伴']"></partners>
    </div>
    <div class="footer">
      <div class="container">
        <span>© 2018 Geekbang Technology Ltd. All rights reserved.</span>
      </div>
    </div>

    <div class="util-edit-wrap" v-if="status === 'editing'">
      <a class="util-btn is-edit" @click="dashboard.editing = !dashboard.editing">编辑</a>
      <a class="util-btn is-download" @click="gethtml">下载页面</a>
      <a class="util-btn is-download" @click="getJson">下载数据</a>
      <a class="util-btn is-edit" href="http://wxcms.geekbang.org/admin/editor/index" target="_blank">打开图床</a>
      <div
        class="util-dashboard"
        v-show="dashboard.editing"
        @mousedown="mousedown"
        @mouseup="mouseup"
        :style="{left: dashboard.left, top:dashboard.top}">
        <div class="util-dashboard-wrap">
          <editor :data="data"></editor>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import data from './data'
  import NavInfoq from '@/components/navinfoq'
  import GiNav from '@/components/nav'
  import GiTitle from '@/components/title'
  import GiCard from '@/components/card'
  import GiCard2 from '@/components/card2'
  import editor from '@/components/editor'
  import download from './vender/download'
  import temp from './temp'
  import Scheduleb from './scheduleb'
  import Speakers from './speakers'
  import Partners from './components/partners/partners'

  export default {
    components: {
      editor,
      NavInfoq,
      GiNav,
      GiTitle,
      GiCard,
      GiCard2,
      Scheduleb,
      Speakers,
      Partners
    },
    data () {
      var d = window.GEEKBANG_DATA || data
      d['实时报道'].list.sort((m, n) => {
        if (Number(m['排序']) > Number(n['排序'])) {
          return -1
        }
        if (Number(m['排序']) < Number(n['排序'])) {
          return 1
        }
        return 0
      })
      return {
        swiperOption: {
          pagination: '.swiper-pagination',
          paginationClickable: true,
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev'
        },
        status: 'prod', // prod, editing
        dashboard: {
          editing: false,
          dragstartx: 0,
          dragstarty: 0,
          left: '20px',
          top: '20px',
          draging: false
        },
        data: d,
        newsbac: d['实时报道'].list,
        news: d['实时报道'].list.slice(0, 6),
        videos: d['视频回放'].list.slice(0, 3),
        btnShow: false
      }
    },
    computed: {
    },
    methods: {
      len (arr) {
        return arr.filter(d => d['图片']).length
      },
      moreNews () {
        this.news = this.newsbac
      },
      moreVideo () {
        this.videos = this.data['视频回放'].list
      },
      initWxConfig () {
        let data = this.data['微信分享']
        const ua = window.navigator.userAgent
        if (!ua.match(/MicroMessenger/i)) return
        let url = window.location.href
        axios.get(`https://misc.geekbang.org/wxmisc/wxshare/sign?url=${encodeURIComponent(url)}&mpid=geekbang`)
        .then(res => {
          if (res.data.code === 0) {
            if (!window.wx) return
            window.wx.config({
              debug: false,
              appId: res.data.data.appId,
              timestamp: res.data.data.timestamp,
              nonceStr: res.data.data.nonceStr,
              signature: res.data.data.signature,
              jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
            })
          }
        })
        window.wx.ready(function () {
          window.wx.onMenuShareTimeline({
            title: data['标题'],
            imgUrl: data['图片'],
            link: window.location.href,
            success: function () {},
            cancel: function () {}
          })
          window.wx.onMenuShareAppMessage({
            title: data['标题'],
            desc: data['介绍'],
            imgUrl: data['图片'],
            link: window.location.href,
            type: 'link',
            dataUrl: '',
            success: () => {},
            cancel: () => {}
          })
        })
      },
      // editing
      gethtml () {
        if (!document.querySelector('#app-css')) return
        let css = document.querySelector('#app-css') && document.querySelector('#app-css').outerHTML
        let js = document.querySelector('#app-js') && document.querySelector('#app-js').outerHTML
        let data = JSON.stringify(this.data)
        download(temp.generateHtml(this.data.head, data, css, js), 'index.html', 'text/html')
      },
      getJson () {
        let data = JSON.stringify(this.data, null, '  ')
        download(data, 'data.json', 'text/json')
      },
      mousedown (e) {
        if (e.target === e.currentTarget) {
          this.dashboard.draging = true
          var moveElemRect = e.currentTarget.getBoundingClientRect()
          this.dashboard.dragstartx = e.clientX - moveElemRect.left // 鼠标按下时和选中元素的坐标偏移:x坐标
          this.dashboard.dragstarty = e.clientY - moveElemRect.top // 鼠标按下时和选中元素的坐标偏移:y坐标
        }
      },
      mouseup () {
        this.dashboard.draging = false
      },
      showMenu () {
        this.btnShow = !this.btnShow
      }
    },
    created () {
      // axios.get('https://static-data.geekbang.org/aws2017/data.json')
      // .then(res => {
      //   this.newsbac = res.data.articles.map(a => {
      //     var arr = a.description.split('#time#')
      //     a.description = arr[0]
      //     a.tip = arr[1]
      //     return a
      //   })
      //   this.news = res.data.articles.slice(0, 6)
      // })

      this.initWxConfig()
      if (window.location.protocol.indexOf('file') > -1 ||
          window.location.search.indexOf('status=editing') > -1) {
        this.status = 'editing'
      }
      window.onmousemove = (e) => {
        if (this.dashboard.draging) {
          this.dashboard.left = e.clientX - this.dashboard.dragstartx + 'px'
          this.dashboard.top = e.clientY - this.dashboard.dragstarty + 'px'
        }
      }
    },
    mounted () {
    }
  }
</script>

<style lang="sass">
  @import "style/variable"
  .util-edit-wrap
    position: fixed
    bottom: 20px
    left: 20px
    display: flex
    z-index: 1000
    opacity: 0.2
    transition: All ease-in-out 0.4s
    &:hover
      opacity: 0.6
  .util-btn
    margin-right: 20px
    display: flex
    color: #fff
    font-size: 16px
    border-radius: 5px
    padding: 10px 20px
    cursor: pointer
    z-index: 1000
    transition: opacity 0.3s
    user-select: none
    &:hover
      opacity: 0.8
  .util-btn.is-edit
    background-color: blue
  .util-btn.is-download
    background-color: green
  .util-dashboard
    cursor: move
    display: block
    position: fixed
    padding: 40px 0 0 0
    width: 50%
    height: 80%
    background: #999
    box-shadow: 0 0 20px 0 #888
    border-top-right-radius: 15px
    border-top-left-radius: 15px
  .util-dashboard-wrap
    cursor: default
    padding: 0 20px
    background: #000
    width: 100%
    height: 100%
    overflow: scroll
    border-bottom-right-radius: 15px
    border-bottom-left-radius: 15px
  .btn-area
    width: 100%
    position: relative
    +mobile
      .content
        display: flex
        height: 42px
        background-color: #1165c8
        flex-direction: row
        justify-content: space-around
        align-items: center
        .precon
          color: #ffffff
          font-size: 14px
          display: inline-block
          border-bottom: solid 1px #fff
          margin-right: 20px
        .prelive
          color: #ffffff
          font-size: 14px
          display: inline-block
          border-bottom: solid 1px #fff
          margin-right: 60px
        .togzsite
          color: #ffffff
          font-size: 14px
          display: inline-block
        .btn-menu
          display: none
    +tablet
      height: 0
      display: flex
      flex-direction: row
      justify-content: center
      align-items: center
      .content
        position: absolute
        top: -86px
        width: 170px
        flex-direction: column
        justify-content: flex-start
        align-items: center
        .togzsite
          display: none
        .btn-menu
          width: 100%
          display: flex
          flex-direction: column
          align-items: center
          text-align: center
          color: #ffffff
          font-size: 14px
          line-height: 14px
          border: 1px solid transparent;
          border-image: linear-gradient(to right, #2bf9d2, #2175fb)
          border-image-slice: 1;
          .site-cq
            width: 100%
            height: 30px
            padding: 8px
            position: relative
            .arrowicon-b
              display: inline-block
              width: 14px;
              height: 10px;
              background-image: url('../static/img/bottom.png')
              background-repeat: no-repeat
              background-size: 100%
              background-position: center
            .arrowicon-t
              display: inline-block
              width: 14px;
              height: 10px;
              background-image: url('../static/img/top.png')
              background-repeat: no-repeat
              background-size: 100%
              background-position: center
          .site-gz
            display: block
            width: 100%
            height: 30px
            padding: 8px
            position: absolute
            top: 32px
            color: #000
            background-image: linear-gradient(to right, #2bf9d2, #2175fb)
        .btn-group
          opacity: 1
          display: flex
          flex-direction: row
          justify-content: space-around
          align-items: center
          color: #ffffff
          font-size: 14px
          padding: 8px
          .precon
            border-bottom: solid 1px #ffffff
          .prelive
           border-bottom: solid 1px #ffffff
</style>



// WEBPACK FOOTER //
// src/App.vue